import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Educational",
  icon: "🧠",
  templates: [
    {
      title: "Explain It Simply",
      content: `Explain the topic of [how vaccines train the immune system] in a clear and engaging way for listeners.
- Imagine explaining it to [a curious teenager with no science background].
- Use a relatable analogy: [compare it to a fire drill — you practice for something so you're ready when the real thing happens].
- Avoid jargon; when a technical term is needed, define it immediately in plain language.
- Write in a warm, encouraging tone that makes the listener feel smart, not talked down to.`
    },
    {
      title: "Documentary Voiceover",
      content: `Write a documentary-style voiceover narration.
- Subject: [the daily life of street food vendors in Bangkok].
- Angle: [the craft, pride, and generational knowledge behind dishes that look simple but take years to master].
- Tone: [respectful, vivid, and unhurried — let the scenes breathe].
- Include sensory details that help the listener picture and feel the environment: [the sizzle of a wok, the humidity of a morning market, the precise hand movements of a vendor who has done this ten thousand times].
- Write in present tense for immediacy.`
    },
    {
      title: "Guided Meditation",
      content: `Write a guided meditation script designed to be listened to.
- Goal: [releasing tension after a long workday and easing into the evening].
- Guide the listener to visualize [a quiet lakeside at sunset — warm light on the water, a gentle breeze, the sound of distant birds settling in for the night].
- Tone: [calm, unhurried, and grounding].
- Approximate spoken duration: [8 minutes].
- Use plenty of natural pauses (marked with "...") between instructions. Keep sentences short and gentle. Avoid sudden shifts in energy.`
    }
  ]
};
